export default __webpack_public_path__ + "static/media/Walker's Gloves of the Clans.de717805.jpg";